import { render } from "./InputWriter.vue?vue&type=template&id=88906d02"
import script from "./InputWriter.vue?vue&type=script&lang=js"
export * from "./InputWriter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__